<template>
  <div class="icon-row">
    <a
      class="stock"
      href="https://www.shutterstock.com/g/mathiasmoeller?rid=180029162&utm_medium=email&utm_source=ctrbreferral-link"
      target="_blank"
    >
      <img class="stock-logo" src="/img/logos/shutterstock.svg">
    </a>
    <a
      class="stock"
      href="https://stock.adobe.com/de/contributor/207290141/Mathias"
      target="_blank"
    >
      <img class="stock-logo" src="/img/logos/adobe_stock.png">
    </a>
    <a
      class="stock"
      href="https://www.dreamstime.com/mathiasmoeller_info#res30849093"
      target="_blank"
    >
      <img class="stock-logo dreamstime" src="/img/logos/dreamstime.png">
    </a>
    <a
      class="stock"
      href="https://www.istockphoto.com/de/portfolio/mathias.moeller?assettype=image&sort=mostpopular"
      target="_blank"
    >
      <img class="stock-logo istock" src="/img/logos/istock.svg">
    </a>
  </div>
</template>

<script>
  export default {
    name: 'stock',
    bodyClass: 'profile-page',
  };
</script>

<style lang="scss" scoped>
  @import "../assets/scss/now-ui-kit/_variables";

  .stock {
    margin: 0 12px;
  }

  .icon-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    .nav-link {
      font-size: 32px;
      color: $black-color;
    }
  }

  .stock-logo {
    max-height: 70px;
    max-width: 200px;
    object-fit: contain;
    padding: 0.5rem 1rem;

    &.istock {
      max-height: 50px;
      margin-bottom: -8px;
    }

    &.dreamstime {
      margin-bottom: 12px;
    }
  }

</style>
